import UserProfile from '../UserProfile';
import JournalMarche from '../JournalMarche';

export const clearSession = () => {
    UserProfile.clearSession();
    JournalMarche.clearSession();
};

export const isAuthenticated = () => {
    const token = UserProfile.getToken();
    return token != null && token !== '';
};
